<form [formGroup]="form">
  <div class="row" *ngIf="selectedInvoice">


    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
      <mat-card class=" mat-elevation-z3">

        <mat-form-field class="full-width">
          <input formControlName="billingCompany" type="text" placeholder="Customer Invoicing Company"
            [matAutocomplete]="auto" matInput>
          <mat-autocomplete #auto="matAutocomplete" [displayWith]="displayFn">
            <mat-option *ngFor="let customer of customers | async" [value]="customer"
              (onSelectionChange)='changeCBC(customer)'>
              {{customer.raisonSocial}}
            </mat-option>
          </mat-autocomplete>
        </mat-form-field>


        <mat-form-field class="full-width">
          <mat-select placeholder="Contact" formControlName="contactSelect" (selectionChange)='changeContact()' [compareWith]="compareFn">
            <mat-option *ngFor="let item of contacts | async" [value]="item"   >
              {{item.nom}}
            </mat-option>
          </mat-select>
        </mat-form-field>
        <mat-form-field class="full-width">
          <input matInput type="tel" formControlName="tel" placeholder="Tel" readonly>

          <mat-error>Tel is required</mat-error>

        </mat-form-field>
        <mat-form-field class="full-width">
          <input matInput placeholder="E-Mail" formControlName="mail" readonly>
          <mat-error>E-mail is required</mat-error>
        </mat-form-field>
      </mat-card>



    </div>

    <div class="col-xs-6 col-sm-6 col-md-6 col-lg-6">
      <mat-card class=" mat-elevation-z3">



        <mat-form-field style="width: 40%">
          <mat-select  (selectionChange)='changeSociFact()' placeholder="Company Name" formControlName="company" [compareWith]="compareSociFact">
            <mat-option *ngFor="let item of socifacts | async"  
             [value]="item">
              {{item.raisonSocial}}
            </mat-option>
          </mat-select>
          <mat-error>Company Name is required</mat-error>
        </mat-form-field>&nbsp;
        <mat-form-field style="width: 40%">
          <mat-select placeholder="Currency" [(value)]="selectedDevise" formControlName="currency"
            (selectionChange)='changeDevise()'>
            <mat-select-trigger>

              <div>
                <div style="float: left;">
                  <img width="15" [src]="'assets/img/'+selectedDevise+'.png'" alt="">
                </div>
                <div style="float: left;">
                  <div> {{ selectedDevise  | uppercase}} </div>
                </div>
              </div>

            </mat-select-trigger>
            <mat-option *ngFor="let item of devises" [value]="item.value">
              <img width="20" [src]="'assets/img/'+item.value+'.png'" alt="">
               {{ item.value | uppercase}} - {{ item.label}}
            </mat-option>
          </mat-select>
        </mat-form-field>

        {{selectedInvoice.idfacture}}
<!-- ./../. -->
        <div class="full-width">
          <mat-slide-toggle formControlName="tva"> TVA </mat-slide-toggle> &nbsp;
          <mat-slide-toggle formControlName="timbre"> Timbre </mat-slide-toggle>
          &nbsp;
          <mat-slide-toggle formControlName="finance"> Espéce </mat-slide-toggle> &nbsp;

          <mat-slide-toggle formControlName="annuler"> Annulée </mat-slide-toggle> &nbsp;
        </div>


        <mat-form-field style="width: 40%">
          <input matInput [matDatepicker]="dateInvoice" formControlName="dateInvoice" [(ngModel)]="selectedInvoice.datefacture"
            placeholder="Invoice Date">
          <mat-datepicker-toggle matSuffix [for]="dateInvoice"></mat-datepicker-toggle>
          <mat-datepicker #dateInvoice></mat-datepicker>
          <mat-error>Date is required</mat-error>
        </mat-form-field>
        <mat-form-field style="width: 40%">
          <input matInput   formControlName="montanttva" placeholder="Pourcentage TVA" >
        </mat-form-field>


        <mat-form-field class="full-width">
          <textarea matInput formControlName="observation" placeholder="Notes" rows="7"></textarea>
        </mat-form-field>
      </mat-card>




    </div>

  </div>
<div   class="row" *ngIf="!selectedInvoice">
Pas de données finance veuillez selectioner un contact principal
</div>


</form>